import Url from '@mc/mc-utils/js/url/url'

export const getUserCode = () => {
  const url = new Url(window.location.href)
  const { user_code: userCode } = url.parseQuerystring()
  return userCode
}
